import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import Select from "react-select"
import * as wActs from "../actions/website-actions";
import * as adActs from "../actions/advertise-actions";
import * as bActs from "../actions/billing-actions";
import {FormattedMessage} from "react-intl";
import * as wConst from '../consts/website-consts';
import { Link } from 'react-router-dom';
import DropZone from 'react-dropzone';
//import ProfileSelectBox from '../components/profileselectbox';
import {culturePath} from "../actions/website-actions";
import SwBanner from '../components/swbanner'
import BuyAdBanner from "../components/buyadbanner";
import StepLabel from "../components/adbuy/steplabel";
import AdStepOne from "../components/adbuy/step1";
import PackItem from "../components/adbuy/packitem";
import AdStepTwo from "../components/adbuy/step2";
import AdStepThree from "../components/adbuy/step3";
import OrderAccepted from "../components/adbuy/orderaccepted";
import OrderDeclined from "../components/adbuy/orderdeclined";
import LoadBillerVXS from "../components/adbuy/loadbillervxs";
import PayByCredits from "../components/adbuy/paybycreditsjs";
import CheckOrder from "../components/adbuy/checkorder";
import LoadBillerCuro from "../components/adbuy/loadbillercuro";
import LoadBillerJivo from "../components/adbuy/loadbillerjivo";
import Loading from "../components/loading";
import RightBanners from "../components/rightbanners";


//Using This So I Can Build Buy Page Without Repeating 20 Steps
const testStateStep2 = {
  country: "US",
  homecc: "NL",
  img: null,
  imgHeight: "0px",
  imgName: "",
  imgWidth: "0px",
  loadBiller: "PAY",
  packData: {
    Amount: 30,
    Country: {},
    CurrencyCode: "EUR",
    Description: "Your ad will show in United States on the side bar for 15 days",
    EstimatedDailyVisitors: 0,
    FriendlyName: "United States 15 day 200x333",
    Header: "United States",
    Index: 2,
    IsCountryPackage: true,
    MaxAds: 10,
    Name: "15 day 200x333 size plan",
    PackageId: 2017,
    ShortName: "15 day 200x333",
    Size: "200x333",
    SizeType: "Fixed",
    SoldAds: 0,
    Tokens: 240,
    Type: "Banner"
  },
  packageId: 2017,
  payby: "EUR",
  showingImg: false,
  size: "200x333",
  step: "3",
  title: "",
  upDisabled: true,
  url: "https://www.escortspots.com/sandy-2944",
  usertype: 1
};

const testState = {
  country: "US",
  homecc: "BR",
  imgHeight: 100,
  imgName: "200x100.gif",
  imgWidth: 200,
  packageId: 2024,
  payby: "TOK",
  showingImg: true,
  size: "200x100",
  startDate: "2019-06-01",
  step: "3",
  title: "Fetish Sandy, 25, priveontvangst escort in Belo Horizonte",
  upDisabled: false,
  url: "https://www.topescort.nl/sandy-2944",
  usertype: 1,
  packData: {
    Amount: 50,
    CurrencyCode: "EUR",
    Description: "7 dagen 200x100 formaat",
    IsCountryPackage: true,
    MaxAds: 3,
    Name: "7 dagen 200x100 formaat",
    PackageId: 2024,
    Period: 7,
    Size: "200x100",
    SizeType: "Fixed",
    SoldAds: 0,
    Tokens: 500,
    Type: "Banner",
  }
};
const testUpload = {
  Code: 200,
  Message: "Success",
  Result: {
    "Guid":"c4563f95-5f86-4cda-b8b8-268c77f8e428",
    "Url":"https://cdn.escortspots.com/uploads/c4563f95-5f86-4cda-b8b8-268c77f8e428.gif",
    "FileName":"c4563f95-5f86-4cda-b8b8-268c77f8e428.gif",
    "FileHash":"c70801313bf1eded45818bac3f7d50b6",
    "Length":26809,
    "Width":200,
    "Height":200,
    "OriginalFileName":"other-200x200.gif",
    "OriginalLength":26809
  }
};

class Advertise extends Component {

  //Comp Events
  constructor(props) {
    super(props);
    let dte = new Date();
    let ref = "";

    if(typeof window !== "undefined") {
      ref = window.location.href;
    } else {
      ref = props.WebPage.ServerParams.Referer;
    }


    this.state = {
      step: "1",
      size: props.Ads.AdQuery.size,
      usertype: "",
      homecc: "",
      country: props.Ads.AdQuery.country,
      packageId: props.Ads.AdQuery.packageId,
      packData: {},
      startDate: `${dte.getFullYear()}-${this.zeroPad(dte.getMonth()+1)}-${this.zeroPad(dte.getDate())}`,
      payby: "EUR",
      url: "",
      title: "",
      showingImg: false,
      img: null,
      imgName: "",
      imgWidth: "0px",
      imgHeight: "0px",
      upDisabled: true,
      loadBiller: "PAY"
    };
    this.file = null;
  }
  componentDidMount() {


    this.props.dispatch({ type: wConst.ACTION_SET_PAGETYPE, payload: "advertise" });

    //if(!wActs.isLoggedIn(this.props.WebPage)) {
    //  this.props.history.push(wActs.getCultPath(this.props.WebPage,"/login"));
    //}

    //Test Billing Code
    if (typeof window !== "undefined" && wActs.getParameterByName("testbilling", window.location.href, "")!== "") {
     this.setState(testStateStep2);
     this.props.dispatch(bActs.GetBillingData());
     this.props.dispatch({type: wConst.FETCH_ADUPLOAD_FULLFILLED,payload: testUpload});
     return;
    }



    if(!wActs.isLoggedIn(this.props.WebPage)) {
      this.setState({payby: "EUR"});
    }

    if(typeof window !== "undefined") {
      let tUrl = document.location.href;
      let qDta = {};
      let biller = wActs.getParameterByName("biller",tUrl,"");
      if(biller !== "") {
        switch(biller.toUpperCase()) {
          case "VXS" : {
            let user1 = wActs.getParameterByName("user_1",tUrl,"");
            let user2 = wActs.getParameterByName("user_2",tUrl,"");
            qDta.OrderId = wActs.getParameterByName("order_id",tUrl,"");
            let params = user1.split(":");
            qDta.PackId = params[0];
            qDta.Country = params[1];
            qDta.HomeCountry = params[2];
            qDta.UserId = params[3];
            params = user2.split(":");
            qDta.StartDate = params[1];
            qDta.Guid = params[2];
            qDta.RecordId = 0;
            if(wActs.isLoggedIn(this.props.WebPage)) {
              qDta.RecordId = this.props.WebPage.User.RecordId;
            }
            qDta.TargetUrl = localStorage.getItem("ad-target-url");
            let cPath = this.props.WebPage.Settings.SelectedLocal;
            if(!cPath.startsWith("/")) { cPath = `/${cPath}/`; }
            this.setState({ step: "5", loadBiller: "VXS", bQuery: qDta });
            this.props.dispatch(bActs.VXSCheckOrder(qDta.OrderId, qDta.PackId, qDta.Country, qDta.HomeCountry, qDta.UserId, qDta.RecordId, qDta.StartDate, qDta.Guid, cPath,"EUR", qDta.TargetUrl));
            break;
          }
          case "CURO": {
            let cde = wActs.getParameterByName("code", window.location.href);
            this.setState({ step: "5", loadBiller: "CURO", bQuery: qDta, Approved: wActs.getParameterByName("code", window.location.href) == "success" });
            break;
          }
        }
      }
    }



  }
  componentDidUpdate() {

  }

  //Event handlers
  handleSubmit(rec) {
    window.localStorage.removeItem("biller-data");
    let cc = "";
    let homeCC = "";
    let userType = "";
    let size = "";
    let payby = "";
    let dte = new Date();
    let sdate = `${dte.getFullYear()}-${this.zeroPad(dte.getMonth()+1)}-${this.zeroPad(dte.getDate())}`;
    try {
      cc = rec.country;
      homeCC = rec.homecc;
      userType = rec.usertype;
      size = rec.size;
      payby = rec.payby;
      sdate = rec.startdate;
    } catch(ex){}

    this.sendGoogleEvent("AdBuyPage","SubmitStep1",`Country: ${cc}, User: ${userType}, Size: ${size}, PayBy: ${payby}`);

    if(isNaN(this.state.packageId) || this.state.packageId <= 0) {
      this.props.dispatch(wActs.showWarning("WARN",this.getTranslation("response.pleaseselectapackage")));
      return;
    }

    window.ScrollTopAlways();
    if(!wActs.isLoggedIn(this.props.WebPage)) {
      localStorage.setItem("ad-data",JSON.stringify({
        size: size,
        country: cc,
        packageId: this.state.packageId,
        payby: payby,
        homecc: homeCC,
        usertype: userType,
        startDate: sdate
      }));
      window.ScrollTopAlways();
      this.props.dispatch({type: wConst.LOGIN_SET_URL,payload: document.location.href});
      this.props.history.push(wActs.getCultPath(this.props.WebPage,"/login"));
      return;
    } else {
      if((size !== "Profile" && !this.isAgent()) || this.isModel()) {
        this.fillUrlInfo();
      }
    }
    if(size == "Profile" && !this.isAgent()) {
      try { localStorage.setItem("ad-target-url",this.props.Ads.AdUserInfo.Result.Url); } catch(ex) {}
      this.props.dispatch(bActs.GetBillingData());
      this.setState({step: "3",homecc: homeCC, usertype: userType, size: size, country: cc, payby: payby, startDate: sdate, url: this.props.Ads.AdUserInfo.Result.Url});
    } else {
      this.setState({step: "2",homecc: homeCC, usertype: userType, size: size, country: cc, payby: payby, startDate: sdate, url: this.props.Ads.AdUserInfo.Result.Url});
    }
  }



  sendGoogleEvent(cat,act,lbl) {
    try {
      let id = this.props.WebPage.Settings.GoogleAnalyticsId;
      if(wActs.isNullOrUndefined(id)) {
        console.log("Google Event Error","Have No UA Id Setting");
        return;
      }
      wActs.SendGoogleEvent(id,cat,act,lbl);
    } catch(ex) {
      console.log("Google Event Error",ex.toString());
    }
  }



  handlePackageClick(packId) {
    let pData = this.props.Ads.AdPackages.Result.filter((t)=>{return t.PackageId == packId})[0];
    this.sendGoogleEvent("AdBuyPage","PackageClick",`Package: ${packId}`);
    this.setState({packageId: packId, packData: pData});
  }
  handleAdStepOneValue(type,rec) {
    //console.log(type,rec)
    if(type!=="DATE" && type!=="PAYBY") {
      if(type === "SIZE") {
        this.props.dispatch(adActs.GetAdPackages(rec.country,rec.size,rec.usertype,rec.homecc));
      } else {
        this.props.dispatch(adActs.GetAdSizes(rec.usertype,rec.country,rec.homecc,rec.size));
      }
    }
    //console.log("REC",rec)
    this.setState({payby: rec.payby, size: rec.size, homecc: rec.homecc, country: rec.country, usertype: rec.usertype, startDate: rec.startdate, packageId: 0});
  }
  handleUpload(evt,dta) {
    evt.preventDefault();
    let fn = "";
    let rec = {
      packid: this.state.packageId,
      url: dta.url,
      title: dta.title,
    };

    if(!wActs.isNullOrEmpty(dta.imageUrl)) {
      rec.imageUrl = dta.imageUrl;
      fn = "URL";
    } else {
      rec.file = dta.file; rec.filename = dta.file.name;
      rec.imageUrl = "";
      fn = dta.file.name;
    }

    this.sendGoogleEvent("AdBuyPage","UploadedImage",`File: ${fn}`);

    window.ScrollTopAlways();
    this.props.dispatch(adActs.UploadAd(rec));
    this.props.dispatch(bActs.GetBillingData());
    this.setState({ step: "3", title: dta.title });
  }
  handleBackToBilling(e) {
    e.preventDefault();
    let sdata = window.localStorage.getItem("biller-data");
    let data = null;
    if(!wActs.isNullOrUndefined(sdata)) {
      data = JSON.parse(sdata);
      if(data.Ad.Loaded) {
        this.props.dispatch({type: wConst.FETCH_ADUPLOAD_FULLFILLED, payload: data.Ad})
      }
      //console.log(data);
      this.setState({
        step: "3",
        homecc: data.homecc,
        country: data.country,
        packageId: data.packageId,
        packData: data.packData,
        startDate: data.startDate,
        url: data.url, title: data.title, size: data.size
      });
      this.props.dispatch(bActs.GetBillingData());

    } else {
      this.setState({ step: "3"});
    }
  }
  handleGoBack(e) {
    e.preventDefault();

    this.sendGoogleEvent("AdBuyPage","GoBack",`To: Step1`);

    this.setState({
      step: "1",
    });
    this.props.dispatch(adActs.GetAdPackages(this.state.country,this.state.size,this.state.usertype,this.state.homecc));
  }
  handlePayByCredits(e,cur) {
    e.preventDefault();
    let dta = {
      PackageId: this.state.packageId,
      Guid: this.props.Ads.AdUpload.Result.Guid,
      CurrencyCode: cur,
      CountryCode: this.state.country,
      StartDate: this.state.startDate,
      UserId: this.props.WebPage.User.UserId,
      TargetUrl: this.state.url
    };

    this.sendGoogleEvent("AdBuyPage","PAY",`Credits: ${cur}`);


    window.ScrollTopAlways();
    this.setState({step: "4", loadBiller: "PAY"});
    this.props.dispatch(adActs.PayByCredits(dta));
  }
  handleContinueToBilling(e,dta) {
    e.preventDefault();
    if(!dta.url.startsWith("http://") && !dta.url.startsWith("https://")) {
      this.props.dispatch(wActs.showWarning("WARN",this.getTranslation("response.invalidurl")));
      return;
    }
    window.ScrollTopAlways();
    let title = dta.title;
    localStorage.setItem("ad-target-url",dta.url);
    this.setState({url: dta.url, title: dta.title});
    this.props.dispatch(bActs.GetBillingData());
    this.setState({ step: "3", title: title });
  }
  handleBillerBuy(e,bType) {
    e.preventDefault(); window.ScrollTopAlways();
    let cPath = this.props.WebPage.Settings.SelectedLocal;
    if(!cPath.startsWith("/")) { cPath = `/${cPath}/`; }

    this.sendGoogleEvent("AdBuyPage","PAY",`Biller: ${bType}`);

    window.localStorage.setItem("biller-data",
    JSON.stringify({
      packageId: this.state.packageId,
      country: this.state.country,
      homecc: this.state.homecc,
      userId: this.props.WebPage.User.UserId,
      startDate: this.state.startDate,
      Guid: this.props.Ads.AdUpload.Loaded ? this.props.Ads.AdUpload.Result.Guid : "",
      Ad: this.props.Ads.AdUpload,
      CultPath: cPath,
      Currency: this.state.packData.CurrencyCode,
      packData: this.state.packData,
      url: this.state.url, title: this.state.title, size: this.state.size
    }));

    switch(bType) {
      case "VXS": {
          this.props.dispatch(
            bActs.VXSCreateOrder(
              this.state.packageId,
              this.state.country,
              this.state.homecc,
              this.props.WebPage.User.UserId,
              this.state.startDate,
        this.props.Ads.AdUpload.Loaded ? this.props.Ads.AdUpload.Result.Guid : "",
              cPath,
              this.state.packData.CurrencyCode
            ));
        break;
      }
      case "DIALXS": { //On CURO We Wait Till We Choose Biller Type Again :)

        break;
      }
      case "JIVO": { //On Jivo We Call CreateOrder And Then Load Button
        this.props.dispatch(
          bActs.JivoCreateOrder(
            this.state.packageId,
            this.state.country,
            this.state.homecc,
            this.props.WebPage.User.UserId,
            this.state.startDate,
      this.props.Ads.AdUpload.Loaded ? this.props.Ads.AdUpload.Result.Guid : "",
            cPath,
            this.state.packData.CurrencyCode,
            this.props.WebPage.User.RecordId,
            this.state.url
          ));
          break;
      }
      default: {
        this.props.dispatch(wActs.showWarning("INFO","Biller code needed"));
        return;
      }
    }
    this.setState({loadBiller: bType, step: "4"});
  }



  //Utility functions
  fillUrlInfo() {
    if(wActs.isLoggedIn(this.props.WebPage)) {
      try {
        let url = this.props.Ads.AdUserInfo.Result.Url;
        this.setState({url: url});
        this.props.dispatch(adActs.GetAdUrlInfo(url));
      } catch(ex) {}
    }
  }
  normalizeDisplayName(str) {
    return str.trim().replace(" ","-").toLowerCase();
  }
  zeroPad(num) {
    if(num<10) {
      return "0" + num;
    } else {
      return "" + num;
    }
  }
  isAgent() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("agent")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  isModel() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("model")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  isUser() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("member")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }
  getTranslationReplace(key,reps) {
    let resp = "";
    try {
      resp = this.props.WebPage.Translations[key];
      reps.map((v) => {
        resp = resp.replace(v.Key, v.Value);
      });
    } catch(ex) {}
    return resp;
  }

  //Render the page
  render() {
    let ccNme = "";
    let aWidth = this.state.size.split("x")[0];
    let aHeight = this.state.size.split("x")[1];
    let isValid = false;
    let tokens = 0; let euros = 0;
    let packs = null;
    let loggedIn = wActs.isLoggedIn(this.props.WebPage);
    let billers = [];
    let showUpload = true;
    let fdta = null;

    let cPath = this.props.WebPage.Settings.SelectedLocal;
    if(!cPath.startsWith("/")) { cPath = `/${cPath}/`; }


    let defTitle = "";

    if(this.props.Ads.Loaded) {
      if(loggedIn) {
        if(this.state.step === "2") {
          if(this.state.size === "Profile") {
            showUpload = false;
          }
        }
      }
      if(this.props.Ads.AdPackages.Loaded) {
        packs = this.props.Ads.AdPackages.Result;
        if(wActs.isNullOrUndefined(packs)) { packs = []; }
      }
      if(this.state.showingImg) {
        if((aWidth == this.state.imgWidth && aHeight == this.state.imgHeight) || this.state.size == "Profile") {
          isValid = true;
        }
      }
      let adUrl = this.props.Ads.AdUrl;
      if(adUrl.Loaded && adUrl.Result.Code == 200) {
        try {
          defTitle = adUrl.Result.Result.Title.trim();
        } catch(ex) {}
      }

      //Setup For Step 3 Here
      if(this.state.step == "3") {
        if(this.props.Billing.Loaded) {
          let sBillers = this.props.Billing.BillingData.SiteBillers.filter((t) => {return t.Domain === wActs.getSubdomain(document.location.hostname)});
          sBillers.map((v) => {
            let tBill = this.props.Billing.BillingData.Billers.filter((t) => {return t.Id === v.BillerId})[0];
            if(!wActs.isNullOrUndefined(tBill)) {
              billers.push(tBill);
            }
          });
        }
      }
    }




    let stepIn = "";
    let step = this.state.step;
    switch(step) {
      case "1": {
        stepIn = this.getTranslation("page.advertise.step1.text");
        break;
      }
      case "2": {
        stepIn = this.getTranslation("page.advertise.step2.text");
        break;
      }
      case "3": {
        if(this.state.size == "Profile" && !this.isAgent()) {
          step = 2;
        }
        stepIn = this.getTranslation("page.advertise.step3.text");
        break;
      }
      default: {break;}
    }

    if(!this.props.WebPage.PageLoaded || !this.props.Ads.Loaded) {
      return (
        <Loading/>
      );
    }

    let showBan = this.props.WebPage.Settings.ShowRightBanners;
    let isAdult = wActs.isAdult(this.props.WebPage);
    return (
      <React.Fragment>
        <SeoHeaders Position={"Top"}/>
        <div className="content-wrap">
          <div className={`cell ${showBan ? "x9" : "x12"}`}>
            <div className="white-box advertise-content white-wrap the-content">
              <div className="alt-form mb">
                <form className="select-block">
                  {(this.props.PriceList.Loaded && this.props.PriceList.ApiResult.Code == 200) &&
                  <div className="row" style={{fontSize: "20px"}}>

                    {this.props.PriceList.ApiResult.Result.map((grp,idx)=>{
                      return (
                        <div className="col_100">
                          <div className="white-box">
                            <div className="girl-widget">
                              {grp.Countries.length<15 ?
                                <div className="widget-header" style={{background: "#414046"}}><h4 style={{marginBottom: "5px"}}>{grp.Name}</h4>
                                  {grp.Countries.map((c,i)=>{
                                    if(i>5) {return;}
                                    let rght = 20 * (i+1);
                                    return <img key={"ccimg-" + i} src={`/imgs/ccs/${c.Code.toLowerCase()}.svg`} alt={c.Code} style={{right: `${rght}px`}} />
                                  })}
                                </div>
                                :
                                <div className="widget-header" style={{background: "#414046"}}><h4 style={{marginBottom: "5px"}}>{grp.Name}</h4></div>
                              }
                              {grp.Countries.length>5 &&
                              <div key={"ccs" + idx} className="price-list-mcc col_100" style={{whiteSpace: "break-spaces"}}><span style={{color: "red",fontSize: "11px"}}>*</span>&nbsp;{grp.Countries.map((c,i)=>{if(i<=5) {return null;} return <span style={{fontSize: "11px"}}>{c.Name}{(i == grp.Countries.length-1) ? "" : ", "}</span>})}</div>
                              }

                              {grp.Groups &&
                              <React.Fragment>
                                {grp.Groups.map((grps,idx)=>{
                                  let itms = grps.Items.map((itm,itmI)=> {
                                    return (
                                      <React.Fragment>
                                        <div key={"itm-" + itmI + "nme-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className={`price-list-option${itmI % 2 == 0 ? "" : "-alt"} col_55`}>{itm.ShortName}</div>
                                        <div key={"itm-" + itmI + "price-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className={`price-list-option${itmI % 2 == 0 ? "" : "-alt"} col_15`}>{itm.Price}</div>
                                        <div key={"itm-" + itmI + "aprice-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className={`price-list-option${itmI % 2 == 0 ? "" : "-alt"} col_15 ${wActs.isNullOrEmpty(itm.AgentPrice) ? "" : "font-muted"}`}>{wActs.isNullOrEmpty(itm.AgentPrice) ? itm.Price : itm.AgentPrice}</div>
                                        <div key={"itm-" + itmI + "lprice-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className={`price-list-option${itmI % 2 == 0 ? "" : "-alt"} col_15 ${wActs.isNullOrEmpty(itm.LocalPrice) ? "" : "font-muted"}`}>{wActs.isNullOrEmpty(itm.LocalPrice) ? itm.Price : itm.LocalPrice}</div>
                                      </React.Fragment>
                                    );
                                  });
                                  return (
                                    <React.Fragment>
                                      <div key={"grps-"+idx} className="price-list-header col_100">{grps.Name}{grps.Size ? " - "+grps.Size : ""}{grps.Header ? <span style={{color: "#47db1a", fontSize: "16px", float: "right"}}>{grps.Header}</span> : ""}<div className="col_100" style={{fontSize: "12px", color: "#8d8b8b"}}>{grps.Description}</div></div>
                                      <div key={"hdr-nme-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className="price-list-theader col_55">{this.getTranslation("dash.name")}</div>
                                      <div key={"hdr-price-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className="price-list-theader col_15">{this.getTranslation("page.advertise.price")}</div>
                                      <div key={"hdr-aprice-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className={`price-list-theader col_15`}>{this.getTranslation("page.advertise.bulk")}</div>
                                      <div key={"hdr-lprice-"+idx} style={{fontSize: "12px",borderBottom: "solid 1px #454545"}} className={`price-list-theader col_15`}>{this.getTranslation("menu.local")}</div>
                                      {itms}
                                    </React.Fragment>
                                  );
                                })}
                              </React.Fragment>
                              }
                              {!grp.Groups &&
                              <React.Fragment>
                                <div key={"ccs" + idx} className="price-list-mcc col_100" style={{display: "block", whiteSpace: "break-spaces", fontSize: "12px"}}>{this.getTranslation("page.comingsoon")}</div>
                              </React.Fragment>
                              }

                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  }


                  {/*(this.props.Ads.Loaded && this.state.step<4) &&
                    <StepLabel
                      stepText={this.getTranslationReplace("page.advertise.stepx",[{Key: "{{step}}",Value:step}])}
                      instructionText={stepIn}
                      adTextHeader={this.getTranslation("page.advertise.promo1")}
                      adText={this.getTranslationReplace(isAdult ? "page.advertise.promo1.text" : "page.advertise.promo1.text.noescort",[{Key: "{{SiteName}}",Value: this.props.WebPage.Settings.SiteName}])}
                    />
                  */}
                  {/*this.props.Ads.Loaded && this.state.step === "1" &&
                      <AdStepOne
                        changeValue = {(type,rec) => {this.handleAdStepOneValue(type,rec)}}
                        packs = {packs}
                        payBy = {this.state.payby}
                        packageClick = {(packId) => {
                          this.handlePackageClick(packId);
                        }}
                        packageId = {this.state.packageId}
                        handleSubmit = {(rec) => {this.handleSubmit(rec)}}
                        size = {this.state.size}
                        startDate = {this.state.startDate}
                        country = {this.state.country}
                        homecc = {this.state.homecc}
                      />
                  */}
                  {this.props.Ads.Loaded && this.state.step === "2" &&
                      <AdStepTwo
                        country = {this.state.country}
                        size = {this.state.size}
                        startDate = {this.state.startDate}
                        showUpload = {showUpload}
                        isAgent = {this.isAgent()}
                        Url = {wActs.isNullOrEmpty(this.state.url) ? this.props.Ads.AdUserInfo.Result.Url : this.state.url}
                        handleGoBack = {(e) =>{this.handleGoBack(e)}}
                        handleUpload = {(e,dta) => {this.handleUpload(e,dta)}}
                        handleContinueToBilling = {(e,dta) => {this.handleContinueToBilling(e,dta)}}
                        handleUrlChange = {(e,url) => {
                          this.setState({url: url});
                        }}
                      />
                  }
                  {this.props.Ads.Loaded && this.state.step === "3" &&
                      <AdStepThree
                        country = {this.state.country}
                        size = {this.state.size}
                        startDate = {this.state.startDate}
                        showUpload = {showUpload}
                        isAgent = {this.isAgent()}
                        packName = {this.state.packData.Name}
                        packData = {this.state.packData}
                        targetUrl = {this.state.url}
                        handlePayByCredits = {(e,cur) => {this.handlePayByCredits(e,cur)}}
                        handleBillerBuy = {(e,bType) => {this.handleBillerBuy(e,bType)}}
                        handleGoBack = {(e) => {
                          if(this.state.size=="Profile" && !this.isAgent()) {
                            this.setState({step: "1"});
                          } else {
                            this.setState({step: "2"});
                          }
                        }}
                        />

                  }

                  {(this.props.Ads.Loaded && this.state.step === "4" && this.state.loadBiller === "PAY") &&
                    <PayByCredits/>
                  }
                  {(this.props.Ads.Loaded && this.state.step === "4" && this.state.loadBiller === "VXS") &&
                    <LoadBillerVXS/>
                  }
                  {(this.props.Ads.Loaded && this.state.step === "4" && this.state.loadBiller === "DIALXS") &&
                    <LoadBillerCuro
                      handleBackToBilling = {(e) => {this.handleBackToBilling(e)}}
                      Transaction = {{
                        Country: this.state.country,
                        HomeCountry: this.state.homecc,
                        URL: this.state.url,
                        PayBy: this.state.payby,
                        packData: this.state.packData,
                        packageId: this.state.packageId,
                        title: this.state.title,
                        UserType: this.state.usertype,
                        StartDate: this.state.startDate,
                        UserId: this.props.WebPage.User.UserId,
                        Guid: this.props.Ads.AdUpload.Result.Guid,
                        CulturePath: cPath,
                        CurrencyCode: this.state.packData.CurrencyCode,
                        RecordId: this.props.WebPage.User.RecordId
                      }}
                    />
                  }
                  {(this.props.Ads.Loaded && this.state.step === "4" && this.state.loadBiller === "JIVO") &&
                  <LoadBillerJivo
                    handleBackToBilling = {(e) => {this.handleBackToBilling(e)}}
                  />
                  }

                  {(this.props.Ads.Loaded && this.state.step === "5" && this.state.loadBiller === "VXS") &&
                  <CheckOrder
                    handleBackToBilling = {(e) => {this.handleBackToBilling(e)}}
                  />
                  }
                  {(this.props.Ads.Loaded && this.state.step === "5" && this.state.loadBiller === "CURO" && this.state.Approved) &&
                    <OrderAccepted OrderId={wActs.getParameterByName("transaction",window.location.href)}/>
                  }
                  {(this.props.Ads.Loaded && this.state.step === "5" && this.state.loadBiller === "CURO" && !this.state.Approved) &&
                    <OrderDeclined Message={"Rejected"}  OrderId={wActs.getParameterByName("transaction",window.location.href)}/>
                  }



                </form>
              </div>

              <div className="padding-div" style={{height: "50px"}}>&nbsp;</div>


            </div>
          </div>
          {(showBan && isAdult) &&
            <div className="cell x3">
              <RightBanners/>
            </div>
          }
          <SeoHeaders Position={"Bottom"}/>

        </div>
      </React.Fragment>
    );

  }





}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Ads: state.Ads,
    Billing: state.Billing,
    CreateOrder: state.Billing.CreateOrder,
    CheckOrder: state.Billing.CheckOrder,
    PriceList: state.Ads.PriceList,

  };
};

export default connect(mapStateToProps)(Advertise);
